/**
 * Método responsável pela retirada de acentos em strings processadas dentro do javascript
 * @param palavra String acentuada
 * @return String sem acentos
 */
function retira_acentos(palavra) {
    var com_acento = 'áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ';
    var sem_acento = 'aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC';
    var nova = '';
    for (i = 0; i < palavra.length; i++) {
        if (com_acento.search(palavra.substr(i, 1)) >= 0) {
            nova += sem_acento.substr(com_acento.search(palavra.substr(i, 1)), 1);
        } else {
            nova += palavra.substr(i, 1);
        }
    }
    return nova;
}


/****************************************************************************
 * Flash Tag Write Object v1.2b - by Lucas Fererira - www.lucasferreira.com  *
 * Info and Usage: www.lucasferreira.com/flashtag                            *
 * bugs/reports: contato@lucasferreira.com                                   *
 ****************************************************************************/
if (Browser == undefined) {
    var Browser = {
        isIE: function() {
            return (window.ActiveXObject && document.all && navigator.userAgent.toLowerCase().indexOf("msie") > -1 && navigator.userAgent.toLowerCase().indexOf("opera") == -1) ? true : false;
        }
    };
}

var Flash = function(movie, id, width, height, initParams) {
    this.html = "";
    this.attributes = this.params = this.variables = null;

    this.variables = new Array();
    this.attributes = {
        "classid": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
        "codebase": "https://fpdownload.macromedia.com/get/flashplayer/current/swflash.cab#version=8,0,22,0",
        "type": "application/x-shockwave-flash"
    };
    this.params = {"pluginurl": "https://www.macromedia.com/go/getflashplayer_br"};

    if (movie) {
        this.addAttribute("data", movie);
        this.addParameter("movie", movie);
    }

    if (id && id != null) this.addAttribute("id", id);
    if (width) this.addAttribute("width", width);
    if (height) this.addAttribute("height", height);

    if (initParams != undefined) {
        for (var i in initParams) {
            if (initParams.hasOwnProperty(i)) {
                this.addParameter(i + '', initParams[i]);
            }
        }
    }

};
Flash.version = "1.2b";
Flash.getObjectByExceptions = function(obj, excep) {
    var tempObj = {};
    for (var i in obj) {
        var inclui = true;
        for (var j = 0; j < excep.length; j++) {
            if (excep[j] == i.toString()) {
                inclui = false;
                break;
            }
        }
        if (inclui) tempObj[i] = obj[i];
    }
    return tempObj;
};
Flash.prototype.addAttribute = function(prop, val) {
    this.attributes[prop] = val;
};
Flash.prototype.addParameter = function(prop, val) {
    this.params[prop] = val;
};
Flash.prototype.addVariable = function(prop, val) {
    this.variables.push([prop, val]);
};
Flash.prototype.getFlashVars = function() {
    var tempString = new Array();

    for (var i = 0; i < this.variables.length; i++)
        tempString.push(this.variables[i].join("="));

    return tempString.join("&");
};
Flash.prototype.toString = function() {
    this.params.flashVars = this.getFlashVars();
    var attr, params, i;
    if (Browser.isIE()) {
        //IE
        this.html = "<ob" + "ject";
        attr = Flash.getObjectByExceptions(this.attributes, ["type", "data"]);
        for (i in attr) if (i.toString() != "extend") this.html += " " + i.toString() + " = \"" + attr[i] + "\"";
        this.html += "> ";
        params = Flash.getObjectByExceptions(this.params, ["pluginurl", "extend"]);
        for (i in params) if (i.toString() != "extend") this.html += "<param name=\"" + i.toString() + "\" value=\"" + params[i] + "\" /> ";
        this.html += " </obj" + "ect>";
    } else {
        //non-IE
        this.html = "<!--[if !IE]> <--> <obj" + "ect";
        attr = Flash.getObjectByExceptions(this.attributes, ["classid", "codebase"]);
        for (i in attr) if (i.toString() != "extend") this.html += " " + i.toString() + " = \"" + attr[i] + "\"";
        this.html += "> ";
        params = Flash.getObjectByExceptions(this.params, ["extend"]);
        for (i in params) if (i.toString() != "extend") this.html += "<param name=\"" + i.toString() + "\" value=\"" + params[i] + "\" /> ";
        this.html += " </obj" + "ect> <!--> <![endif]-->";
    }
    return this.html;
};
Flash.prototype.write = Flash.prototype.outIn = Flash.prototype.writeIn = function(w) {
    if (typeof w === "string" && document.getElementById) var w = document.getElementById(w);
    if (w != undefined && w) w.innerHTML = this.toString();
    else document.write(this.toString());
};

//v1.7
// Flash Player Version Detection
// Detect Client Browser type
// Copyright 2005-2007 Adobe Systems Incorporated.  All rights reserved.
var isIE = (navigator.appVersion.indexOf("MSIE") != -1) ? true : false;
var isWin = (navigator.appVersion.toLowerCase().indexOf("win") != -1) ? true : false;
var isOpera = (navigator.userAgent.indexOf("Opera") != -1) ? true : false;

function ControlVersion() {
    var version;
    var axo;
    var e;

    // NOTE : new ActiveXObject(strFoo) throws an exception if strFoo isn't in the registry
    try {
        // version will be set for 7.X or greater players
        axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.7");
        version = axo.GetVariable("$version");
    } catch (e) {
    }

    if (!version) {
        try {
            // version will be set for 6.X players only
            axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.6");

            // installed player is some revision of 6.0
            // GetVariable("$version") crashes for versions 6.0.22 through 6.0.29,
            // so we have to be careful.

            // default to the first public version
            version = "WIN 6,0,21,0";

            // throws if AllowScripAccess does not exist (introduced in 6.0r47)
            axo.AllowScriptAccess = "always";

            // safe to call for 6.0r47 or greater
            version = axo.GetVariable("$version");

        } catch (e) {
        }
    }

    if (!version) {
        try {
            // version will be set for 4.X or 5.X player
            axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.3");
            version = axo.GetVariable("$version");
        } catch (e) {
        }
    }

    if (!version) {
        try {
            // version will be set for 3.X player
            axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash.3");
            version = "WIN 3,0,18,0";
        } catch (e) {
        }
    }

    if (!version) {
        try {
            // version will be set for 2.X player
            axo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
            version = "WIN 2,0,0,11";
        } catch (e) {
            version = -1;
        }
    }

    return version;
}

// JavaScript helper required to detect Flash Player PlugIn version information
function GetSwfVer() {
    // NS/Opera version >= 3 check for Flash plugin in plugin array
    var flashVer = -1;

    if (navigator.plugins != null && navigator.plugins.length > 0) {
        if (navigator.plugins["Shockwave Flash 2.0"] || navigator.plugins["Shockwave Flash"]) {
            var swVer2 = navigator.plugins["Shockwave Flash 2.0"] ? " 2.0" : "";
            var flashDescription = navigator.plugins["Shockwave Flash" + swVer2].description;
            var descArray = flashDescription.split(" ");
            var tempArrayMajor = descArray[2].split(".");
            var versionMajor = tempArrayMajor[0];
            var versionMinor = tempArrayMajor[1];
            var versionRevision = descArray[3];
            if (versionRevision == "") {
                versionRevision = descArray[4];
            }
            if (versionRevision[0] == "d") {
                versionRevision = versionRevision.substring(1);
            } else if (versionRevision[0] == "r") {
                versionRevision = versionRevision.substring(1);
                if (versionRevision.indexOf("d") > 0) {
                    versionRevision = versionRevision.substring(0, versionRevision.indexOf("d"));
                }
            }
            flashVer = versionMajor + "." + versionMinor + "." + versionRevision;
        }
    }
    // MSN/WebTV 2.6 supports Flash 4
    else if (navigator.userAgent.toLowerCase().indexOf("webtv/2.6") != -1) flashVer = 4;
    // WebTV 2.5 supports Flash 3
    else if (navigator.userAgent.toLowerCase().indexOf("webtv/2.5") != -1) flashVer = 3;
    // older WebTV supports Flash 2
    else if (navigator.userAgent.toLowerCase().indexOf("webtv") != -1) flashVer = 2;
    else if (isIE && isWin && !isOpera) {
        flashVer = ControlVersion();
    }
    return flashVer;
}

// When called with reqMajorVer, reqMinorVer, reqRevision returns true if that version or greater is available
function DetectFlashVer(reqMajorVer, reqMinorVer, reqRevision) {
    versionStr = GetSwfVer();
    if (versionStr == -1) {
        return false;
    } else if (versionStr != 0) {
        if (isIE && isWin && !isOpera) {
            // Given "WIN 2,0,0,11"
            tempArray = versionStr.split(" ");  // ["WIN", "2,0,0,11"]
            tempString = tempArray[1];      // "2,0,0,11"
            versionArray = tempString.split(","); // ['2', '0', '0', '11']
        } else {
            versionArray = versionStr.split(".");
        }
        var versionMajor = versionArray[0];
        var versionMinor = versionArray[1];
        var versionRevision = versionArray[2];

        // is the major.revision >= requested major.revision AND the minor version >= requested minor
        if (versionMajor > parseFloat(reqMajorVer)) {
            return true;
        } else if (versionMajor == parseFloat(reqMajorVer)) {
            if (versionMinor > parseFloat(reqMinorVer))
                return true;
            else if (versionMinor == parseFloat(reqMinorVer)) {
                if (versionRevision >= parseFloat(reqRevision))
                    return true;
            }
        }
        return false;
    }
}

function AC_AddExtension(src, ext) {
    if (src.indexOf('?') != -1)
        return src.replace(/\?/, ext + '?');
    else
        return src + ext;
}

function AC_Generateobj(objAttrs, params, embedAttrs) {
    var str = '';
    if (isIE && isWin && !isOpera) {
        str += '<object ';
        for (var i in objAttrs) {
            str += i + '="' + objAttrs[i] + '" ';
        }
        str += '>';
        for (var i in params) {
            str += '<param name="' + i + '" value="' + params[i] + '" /> ';
        }
        str += '</object>';
    }
    else {
        str += '<embed ';
        for (var i in embedAttrs) {
            str += i + '="' + embedAttrs[i] + '" ';
        }
        str += '> </embed>';
    }

    document.write(str);
}

function AC_FL_RunContent() {
    var ret =
            AC_GetArgs
                    (arguments, ".swf", "movie", "clsid:d27cdb6e-ae6d-11cf-96b8-444553540000"
                            , "application/x-shockwave-flash"
                            );
    AC_Generateobj(ret.objAttrs, ret.params, ret.embedAttrs);
}

function AC_SW_RunContent() {
    var ret =
            AC_GetArgs
                    (arguments, ".dcr", "src", "clsid:166B1BCA-3F9C-11CF-8075-444553540000"
                            , null
                            );
    AC_Generateobj(ret.objAttrs, ret.params, ret.embedAttrs);
}

function AC_GetArgs(args, ext, srcParamName, classid, mimeType) {
    var ret = new Object();
    ret.embedAttrs = new Object();
    ret.params = new Object();
    ret.objAttrs = new Object();
    for (var i = 0; i < args.length; i = i + 2) {
        var currArg = args[i].toLowerCase();

        switch (currArg) {
            case "classid":
                break;
            case "pluginspage":
                ret.embedAttrs[args[i]] = args[i + 1];
                break;
            case "src":
            case "movie":
                args[i + 1] = AC_AddExtension(args[i + 1], ext);
                ret.embedAttrs["src"] = args[i + 1];
                ret.params[srcParamName] = args[i + 1];
                break;
            case "onafterupdate":
            case "onbeforeupdate":
            case "onblur":
            case "oncellchange":
            case "onclick":
            case "ondblclick":
            case "ondrag":
            case "ondragend":
            case "ondragenter":
            case "ondragleave":
            case "ondragover":
            case "ondrop":
            case "onfinish":
            case "onfocus":
            case "onhelp":
            case "onmousedown":
            case "onmouseup":
            case "onmouseover":
            case "onmousemove":
            case "onmouseout":
            case "onkeypress":
            case "onkeydown":
            case "onkeyup":
            case "onload":
            case "onlosecapture":
            case "onpropertychange":
            case "onreadystatechange":
            case "onrowsdelete":
            case "onrowenter":
            case "onrowexit":
            case "onrowsinserted":
            case "onstart":
            case "onscroll":
            case "onbeforeeditfocus":
            case "onactivate":
            case "onbeforedeactivate":
            case "ondeactivate":
            case "type":
            case "codebase":
            case "id":
                ret.objAttrs[args[i]] = args[i + 1];
                break;
            case "width":
            case "height":
            case "align":
            case "vspace":
            case "hspace":
            case "class":
            case "title":
            case "accesskey":
            case "name":
            case "tabindex":
                ret.embedAttrs[args[i]] = ret.objAttrs[args[i]] = args[i + 1];
                break;
            default:
                ret.embedAttrs[args[i]] = ret.params[args[i]] = args[i + 1];
        }
    }
    ret.objAttrs["classid"] = classid;
    if (mimeType) ret.embedAttrs["type"] = mimeType;
    return ret;
}

var FirstTime = {
    'checkForm': function() {
        var form = jQuery('#FormBrandPage');
        var errors = [], cadaSelect;
        jQuery('select', form).filter(
                function() {
                    if (!jQuery(this).attr('multiple')) {
                        return this;
                    }
                }).each(function() {
            var $this = jQuery(this);
            if (! $this.val().length) {
                errors.push({'Name': $this.attr('name'), 'Message': 'Por favor, selecione uma op&ccedil;&atilde;o.'});
            }
        });

        if (errors.length) {
            Feedback.form({'form': form.attr('id'), 'fields': errors});
            return false;
        }

        SendFormDataByAjaxRunTemplateHistory('Campaign/FirstTime/ProductSearchResult', 'FormBrandPage', {'callback': SetDivContent, 'extra_data': 'campaign_firsttime_productsearch'});
    }
};

//Tirar totalPages e deixar dinamico
var Home = {
    'intervalID': 0,
    'contador': 0,
    'page': 1,
    'totalPages': 3,
    'killByUser': false,

    'killTimeout': function () {
        clearInterval(Home.intervalID);
    },

    'startInterval': function () {
        if (Home.killByUser) {
            return;
        }

        Home.contador = 0;

        var tabs = jQuery('#tablist').children();
        var currentTab = tabs[0];
        var product = 0;

        Home.intervalID = setInterval(function () {
            currentTab = tabs[++Home.contador];
            try {
                product = currentTab.id.split('_')[2];
                Home.highlightShow(product);
            } catch (e) {
                Home.killTimeout();
                if (Home.page < Home.totalPages) {
                    Home.highlight(Home.page + 1);
                } else {
                    Home.page = 1;
                    Home.highlight(Home.page);
                }
            }
        }, 5000);

        return;
    },

    'highlight': function (page, byUser) {
        Home.page = page;

        if (byUser) {
            Home.killTimeout();
            Home.killByUser = true;
        }

        SendDataByAjaxRunTemplate('Product/Modules/HighlightTabs', 'Page=' + page, function(rs) {
            jQuery('#product_highlight_tabs').html(rs);

        });
    },

    'highlightShow': function (productID, byUser) {
        if (byUser) {
            Home.killTimeout();
            Home.killByUser = true;
        }

        var active = jQuery('#product_highlight_tabs').find('.active.fL').first();

        var content = active.attr('id').split('_')[2];

        active.removeClass('active');

        jQuery('#content_tab_' + content).css({'display': 'none'});
        jQuery('#tab_browser_' + productID).addClass('active');
        jQuery('#content_tab_' + productID).css({'display': 'block'});
    }
};

function getSelText() {
    var txt = '';

    if (window.getSelection) {
        txt = window.getSelection();
    } else if (document.getSelection) {
        txt = document.getSelection();
    } else if (document.selection) {
        txt = document.selection.createRange().text;
    } else return;

    return txt;
}


/**
 * Métodos da revista
 */
var Magazine = {

    'ManageListArticles': function(event) {
        var $elem = jQuery(event.target);
        var i, l, thisItemClassName;

        if ($elem.is('a')) {

            var li = $elem.parent();
            var ul = $elem.parents().closest('ul');

            var other_li = li.siblings('li');

            other_li.children('a').removeClass('active');

            $elem.addClass('active');

            var li_id = li.attr('id').split('_');
            var img_id = li_id[0] + '_img_' + li_id[2];

            jQuery('#' + img_id).removeClass('off').siblings('div').addClass('off');
        }
    },

    'ArticleVote': function(idArticle, vote, channelTitle, channelUrl) {
        var channel = {
            'title': channelTitle,
            'url': channelUrl
        };

        SendDataByAjaxRunMethod('id=' + idArticle + '&vote=' + vote, 'Article', 'vote', {'callback': Magazine.ArticleVoteResult, 'extra_data': channel});
    },

    'ArticleVoteResult': function(response, channel) {

        var $elem = jQuery('#article_vote_container');
        var texto = '';

        switch (response) {
            case 3:
                texto = '<div class="alert clearfix"><p class="content bold nomargin">Voc&ecirc; j&aacute; votou nesta mat&eacute;ria. Obrigado.</p></div>';
                break;
            case true:
                texto = '<div class="success clearfix"><p class="content bold nomargin">Obrigado. Sua opini&atilde;o vai nos ajudar muito.</p></div>';
                break;
            default:
                texto = '<div class="alert clearfix"><p class="content bold nomargin">Ocorreu um erro insperado. Por favor, tente novamente.</p></div>';
        }
        $elem.html(texto);
    },

    'ZoomImage': function(imageURL) {
        Pop.open(
                'ZoomImage',
                'Magazine/Pop/ZoomImage',
                'imageURL=' + imageURL, 'default', {'onClose': null, 'onComplete': {'method': function (e) {
            alert(e);
        }, 'args': ''}}
                );
    },

    'PopReceiveNewsletter': function(email) {

        if (email) {

            SendDataByAjaxRunMethod('txEmail=' + email, 'User', 'checkEmailAlreadyExists', {'callback': Magazine.callbackPopReceiveNewsletterUserExists, 'extra_data': email});

        } else {

            Pop.open(
                    'ReceiveNewsletter',
                    'Magazine/Pop/ReceiveNewsletterStep1',
                    '', 'default', {'onClose': null, 'onComplete': {'method': function (e) {
                alert(e);
            }, 'args': ''}}
                    );

        }

    },

    'subscribeNewsletter': function (fieldID) {

        var email = jQuery('#' + fieldID).val();
        var keyword = jQuery('#txKeyword').val();
        var str;

        if (keyword) {
            str = 'txEmail=' + email + '&txKeyword=' + keyword + '&txAjax=1';
        } else {
            str = 'txEmail=' + email + '&txAjax=1';
        }

        if(typeof(email) == 'undefined' || email == '' ){
          Pop.error('RECEBA MATÉRIAS POR EMAIL', 'Ops... Faltou incluir o e-mail. ;)', null, null);
          return;
        }

        var subscriber = SendDataByAjaxRunMethodSync('email=' + email, 'User', 'verifyNewsletterSubscriber');
        escondeLoader();

        if (subscriber == 0) {
            SendDataByAjaxRunMethod(str, 'User', 'subscribeNewsletter', {'callback': Magazine.callbackSubscriberNewsletter, 'extra_data': fieldID});
        } else {
            if (subscriber == 1) {
                Pop.sucess('RECEBA MATÉRIAS POR EMAIL', 'Olá! Você já é assinante da newsletter. Enviamos as matérias a cada 15 dias para seu e-mail.', null, null);
            } else if (subscriber == 2) {
                Pop.sucess('RECEBA MATÉRIAS POR EMAIL', 'Olá! Já enviamos o link de confirmação da newsletter para este e-mail. Agora você só precisa acessá-lo e confirmar o recebimento.', null, null);
            }
        }
    },

    'callbackSubscriberNewsletter': function(response, fieldID) {

      var email = jQuery('#' + fieldID).val();

      if (response == 2) {
            //Exibo o form para que a palavra-chave seja cadastrada
            Pop.open(
                    'ReceiveNewsletterStep2',
                    'Magazine/Pop/ReceiveNewsletterStep2',
                    'txEmail=' + email + '&fieldID='+fieldID, 'default', {'onClose': null, 'onComplete': {'method': function (e) {
                alert(e);
            }, 'args': ''}}
                    );
        } else {

            //exibo uma mensagem de que o email foi enviado
            Pop.open(
                    'ReceiveNewsletterFeedback',
                    'Magazine/Pop/ReceiveNewsletterFeedback',
                    'txEmail=' + email, 'default', {'onClose': null, 'onComplete': {'method': function (e) {
                alert(e);
            }, 'args': ''}}
                    );

        }

    },

    'PopConfirmReceiveNewsletter': function(email) {

        Pop.open(
                'ConfirmNewsletter',
                'Magazine/Pop/ReceiveNewsletterConfirmation',
                '', 'default', {'onClose': null, 'onComplete': {'method': function (e) {
            alert(e);
        }, 'args': ''}}
                );

    },

    'showRSSOptions': function(url) {
        Pop.open('RSSOptions', 'User/RSSOptions', 'url=' + url, 'default', {'onClose': null, 'onComplete': {'method': function (e) {
            alert(e);
        }, 'args': ''}});
    }
};

var Select = {
    'refresh': function(element, options, label, value) {
        var $elem = jQuery(element);

        var $options = jQuery(options);

        if ($options.length) {
            $elem.html('');

            $options.each(function() {
                if (typeof(this) != 'function') {
                    Select.addOption($elem, this[value], this[label]);
                }
            });
        }
    },

    'addOption': function(element, value, label) {
        var $elem = jQuery(element);

        var option = jQuery(document.createElement('option'));

        option.attr('value', value);
        option.attr('label', label);

        var textNode = jQuery(document.createTextNode(label));

        textNode.appendTo(option);

        jQuery(option).appendTo($elem);
    },

    'removeOption': function(element, valueToRemove) {
        var $elem = jQuery(element);

        var optionToRemove = $elem.children('[value=' + valueToRemove + ']');

        optionToRemove.remove();
    },

    'clear': function(element, label, value) {
        var $elem = jQuery(element);

        $elem.html('');

        Select.addOption($elem, value, label);

    },

    'clearAll': function(element) {

        var $elem = jQuery(element);

        $elem.html('');

    },

    'getSelectedOptions': function(element) {
        var $elem = jQuery(element);
        var selectedOptions = new Array();
        var j = 0;

        if ($elem.attr('multiple') || $elem.attr('multiple') ) {
            selectedOptions = $elem.children('option:selected');

            if (selectedOptions.length > 0) {
                return selectedOptions;
            } else {
                return false;
            }

        } else if ($elem.attr('selectedIndex') >= 0 || $elem[0].selectedIndex >= 0) {
            selectedOptions = $elem.children('option:selected');
            return selectedOptions;
        } else {
            return false;
        }
    }
};


var Campaign = {
    'Boyfriends': {
        'confirmationDateNoUser': function(qs, counterID) {
            var qs, name, sign, gender, signAfter, signBefore, returnDate, profileID, url;

            var jsOnArgs = SendDataByAjaxRunMethodSync(qs, 'SignChange', 'getLastSignChange');
            escondeLoader();

            var objSign = jQuery.evalJSON(jsOnArgs);

            if (objSign.length == 0) {

                name = objSign.args.Name;
                sign = objSign.AfterSign.MinorLabel;
                gender = 2;

                qs = 'Name=' + name + '&Sign=' + sign + '&Gender=' + gender;

            } else {

                name = objSign.args.Name;
                signAfter = objSign.AfterSign.MinorLabel;
                signBefore = objSign.BeforeSign.MinorLabel;
                returnDate = objSign.date;
                profileID = objSign.args.profileID;
                gender = 2;

                qs = 'Name=' + name + '&nameProfile=' + name + '&signBefore=' + signBefore + '&signAfter=' + signAfter + '&Date=' + returnDate + '&ProfileIDUser=' + profileID;

            }

            url = '/counter/click/' + counterID + '?' + qs;
            parent.parent.location = url;
        }
    },

    'OptInEmailMarketing' : function() {
        var data;
        //assino o e-mail marketing
        var result = SendDataByAjaxRunMethodSync(1, 'User', 'SetUserReceivePromotionalEmailBanner');
        escondeLoader();

        if (result != 1) {
            data = '&AuxResult=error';
        } else {
            data = '&AuxResult=ok';
        }

        location.href = '/counter/click/619/' + data;
    },

    'OptInTransitAlert' : function() {
        var data;
        //assino o horoscopo por email
        var result = SendDataByAjaxRunMethodSync(1, 'User', 'SetUserReceiveAlertsBanner');
        escondeLoader();

        if (result != 1) {
            data = '&AuxResult=error';
            location.href = '/counter/click/620/' + data;
        } else {
            data = '&AuxResult=ok';
            location.href = '/counter/click/620/' + data;
        }

    },

    'OptInSendRememberBirthTime' : function() {
        var data;
        //informo em quantos dias o usuario sera lembrado para colocar a hora de nascimento
        var result = SendDataByAjaxRunMethodSync(1, 'User', 'SetUserSendRememberBirthTime');
        escondeLoader();

        if (result != 1) {
            data = '&AuxResult=error';
            location.href = '/counter/click/621/' + data;
        } else {
            data = '&AuxResult=ok';
            location.href = '/counter/click/621/' + data;
        }
    },

    'updateNewsletter': function(type, email, user) {
        var type = type;
        var email = email;
        var user = user;
        var data, result;

        var subscriber = SendDataByAjaxRunMethodSync('email=' + email, 'User', 'verifyNewsletterSubscriber');
        escondeLoader();

        if (subscriber == 0) {

            if (user == 1) {
                result = SendDataByAjaxRunMethodSync('&ReceiveMagazineNewsletter=1', 'User', 'SetUserReceiveMagazineNewsletter');
                escondeLoader();
                if (result == 1) {
                    result = 'ok';
                }
            } else {
                result = SendDataByAjaxRunMethodSync('&Email=' + email, 'User', 'subscribeNewsletterBannerFlash');
                escondeLoader();
            }

            if (type == 'square') {
                if (result == 'ok') {
                    data = '&AuxResult=userOk';
                    location.href = '/counter/click/626/' + data;
                } else if (result != 1) {
                    data = '&AuxResult=error';
                    location.href = '/counter/click/626/' + data;
                } else {
                    data = '&AuxResult=ok';
                    location.href = '/counter/click/626/' + data;
                }
            }

            if (type == 'super') {
                if (result == 'ok') {
                    data = '&AuxResult=userOk';
                    location.href = '/counter/click/628/' + data;
                } else if (result != 1) {
                    data = '&AuxResult=error';
                    location.href = '/counter/click/628/' + data;
                } else {
                    data = '&AuxResult=ok';
                    location.href = '/counter/click/628/' + data;
                }
            }

        } else {

            if (subscriber == 1) {
                data = '&AuxResult=subscribeNewsletter';
                if (type == 'square') {
                    location.href = '/counter/click/626/' + data;
                }

                if (type == 'super') {
                    location.href = '/counter/click/628/' + data;
                }
            } else if (subscriber == 2) {

                data = '&AuxResult=confirmNewsletterEmail';
                if (type == 'square') {
                    location.href = '/counter/click/626/' + data;
                }

                if (type == 'super') {
                    location.href = '/counter/click/628/' + data;
                }

            }
        }
    },

    'WomanLanding' : {
        'closeFixed': function(ID) {
            var divSpace;
            SetCookie('WLFC', 1, 0);
            jQuery('#'+ID).hide();
            divSpace = parent.parent.document.getElementById("format_148x143");
            divSpace.innerHTML = "";
        }
    }
};

/**
 * Funções JS da enquete
 * @class Survey
 * @created 27-july-2010 15:28:00
 * @version 1.0
 * @author r.tancman
 *
 * */
var Survey = {
    'reply' : function(form, isPop) {

        var urlSurvey = jQuery('#urlSurvey').val();

        if (typeof(form) == 'undefined' || form == null || form == '') {
            form = 'FormSurvey';
        }
        if (typeof(isPop) == 'undefined' || isPop == null || isPop == '') {
            isPop = null;
        }

        if (typeof(urlSurvey) == 'undefined' || urlSurvey == null || urlSurvey == '') {
            urlSurvey = '/';
        }

        var resultReply = SendFormDataByAjaxRunMethodSync(form, 'SurveyUser', 'ctreply');

        //testo se o resultado e falso ou se e do tipo inteiro
        if (resultReply != false && typeof(resultReply) == 'number') {

            var typeSurvey = jQuery('#hdTypeSurveyID').val();
            var surveyId = jQuery('#hdSurveyIdID').val();

            var data = '&surveyId=' + surveyId + '&answerUserId=' + resultReply + '&typeSurvey=' + typeSurvey + '&url=' + urlSurvey;

            SendDataByAjaxRunTemplate('Survey/Modules/SurveyResult', data, function(content) {
                jQuery('#surveycontent').html(content);
            });

            if (isPop == true) {
                Survey.goCharge(surveyId);
            }

        } else {
            escondeLoader();
            alert('Ops, escolha uma das opções para responder a enquete.');
        }
    },

    'goFace' : function(surveyId, divUpdate) {

        var urlSurvey = jQuery('#urlSurvey').val();

        if (typeof(divUpdate) == 'undefined' || divUpdate == null || divUpdate == '') {
            var divUpdate = 'surveycontent';
        }

        if (typeof(urlSurvey) == 'undefined' || urlSurvey == null || urlSurvey == '') {
            urlSurvey = '/';
        }
        var data = '&surveyID=' + surveyId + '&url=' + urlSurvey;

        SendDataByAjaxRunTemplate('Survey/Modules/SurveyFace', data, function(content) {
            jQuery('#' + divUpdate).html(content);
        });

    },

    'goResult' : function(surveyId, divUpdate) {

        var urlSurvey = jQuery('#urlSurvey').val();

        if (typeof(divUpdate) == 'undefined' || divUpdate == null || divUpdate == '') {
            var divUpdate = 'surveycontent';
        }

        if (typeof(urlSurvey) == 'undefined' || urlSurvey == null || urlSurvey == '') {
            urlSurvey = '/';
        }

        var data = '&surveyId=' + surveyId + '&url=' + urlSurvey;
        SendDataByAjaxRunTemplate('Survey/Modules/SurveyResult', data, function(content) {
            jQuery('#' + divUpdate).html(content);
        });

    },

    'goCharge' :function(surveyId, divUpdate) {

        var urlSurvey = jQuery('#urlSurvey').val();
        var urlSurveyData = jQuery('#urlSurveyData').val();

        if (typeof(divUpdate) == 'undefined' || divUpdate == null || divUpdate == '') {
            divUpdate = 'survey_modules_surveycharge';
        }

        if (typeof(urlSurvey) == 'undefined' || urlSurvey == null || urlSurvey == '') {
            urlSurvey = '/';
        }

        if (typeof(urlSurveyData) == 'undefined' || urlSurveyData == null || urlSurveyData == '') {
            urlSurveyData = false;
        }

        var data = '&surveyId=' + surveyId + '&url=' + urlSurvey + '&urlSurvey=' + urlSurveyData;

        SendDataByAjaxRunTemplate('Survey/Modules/SurveyCharge', data, function(content) {
            jQuery('#' + divUpdate).html(content);
        });

    }

};


/**
 * Método do forum
 */
var Forum = {
    'excludePost': function() {
        var inputs,i,checados = "";
        inputs = document.getElementsByTagName('input');//pegando os inputs e jogando num array
        for (i = 0; i < inputs.length; i++) {//varrendo o array que tem os inputs
            if (inputs[i].type == 'checkbox') { //se os inputs forem checkbox
                if (inputs[i].checked) {
                    checados += inputs[i].value + "#";
                }
            }
        }

        var answer = confirm("Deseja excluir os registros selecionados?")
        if (answer) {
            data = 'txDeletes=' + checados;
            var result = SendDataByAjaxRunMethodSync(data, 'ForumUserAdapter', 'ctdeletePost');
            if (result) {
                location.reload(true);
            } else {
                alert("Nenhuma atividade realizada.");
                escondeLoader();
            }
        }
    },
    'votes': function() { //Método resposnável peela inserção de votos de um usuário na base de dados;
        //desabilito o form
        var $form = jQuery('#idPersonareCPTVote');
        $form.attr('disabled', true);
        //------
        //troco o conteudo da div por seguranca
        var $divUpdate = jQuery('#highlight_vote');
        $divUpdate.removeClass().addClass('votebg_yes');
        $divUpdate.html('<div class="votes_yes"><p id="idTotalVotes"></p></div>');
        //------
        SendFormDataByAjaxRunMethod('PersonareCPTVote', 'ForumUserAdapter', 'sendUserVote', {'callback': Forum.getTopicVotes, 'extra_data': jQuery('#PersonareCPTVote')});
    },

    'getTopicVotes': function () { //Método responsável por retornar a contagem de votos de determinado tópico;
        var response = SendFormDataByAjaxRunMethodSync('PersonareCPTVote', 'ForumUserAdapter', 'getTopicVotes');

        //campaign votes
        var responseCampaign = SendFormDataByAjaxRunMethodSync('PersonareCPTVote', 'ForumUserAdapter', 'getTopicVotesCampaign');

        var data = 'NumberVotes=' + response['votes'] + '&userVoted=' + '1' + '&topicViewed=' + response['topicViewed'] + '&NumberVotesAtCampaign=' + responseCampaign['Cvotes'];
        var template = 'Forum/Votes';
        SendDataByAjaxRunTemplate(template, data, SetDivContent);

    },
    'resetFiltersListTopics': function() {
        jQueryHelper.formReset(jQuery('#FormListTopics'));
    },
    'listsTopics': function(page, direction) {
        var txTitle = jQuery('#txTitle').val();
        var ddOrder = jQuery('#ddOrder').val();
        var data = 'page=' + page + '&txTitle=' + txTitle + '&ddOrder=' + ddOrder;

        var divUpdate = 'ForumSearch';
        var template = 'Forum/Search/ListTopics';
        //Método para utilização de chamadas Ajax de uma Paginaçãao em Template.
        //SetDivContent é uma função de callback responsável por atualizar a informação atualizada do banco da template correnpondente.
        SendDataByAjaxRunTemplate(template, data, SetDivContent);
    }
};


/**
 *@category Função para expandir div
 *@param newHeight - nova altura (ex. 300px)
 *@param newWidth - nova largura  (ex. 500px)
 *@param idDiv - id da div que iremos expandir
 */
function expandableBanner(newHeight, newWidth, idDiv) {
    var $div = jQuery('#' + idDiv);
    if (idDiv == null || typeof(idDiv) == 'undefined' || idDiv == '') {
        return;
    }

    if (newHeight != null || typeof(newHeight) != 'undefined' || newHeight != '') {
        $div.height(newHeight);
    }

    if (newWidth != null || typeof(newWidth) != 'undefined' || newWidth != '') {
        $div.width(newWidth);
    }
}

/**
 *@category Verificar se é mobile o device
 */
function mobilecheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}
